export default __webpack_public_path__ + "static/media/flash.ae8058fb.svg";